import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ActionConfirmationConfig } from '../../../shared/components/action-confirmation-modal/action-confirmation-modal.config';
import { GtwElementsBaseUrlsModel } from '../../../shared/_models/gtw-elements-base-urls.model';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-basket-maintenance-delete',
    templateUrl: './basket-maintenance-delete.component.html',
    styleUrls: ['./basket-maintenance-delete.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class BasketMaintenanceDeleteComponent implements OnInit {

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<string>();

  filterParams: any = {};
  baseURLs: GtwElementsBaseUrlsModel = {'admin':'','api':'','custom':'','efile':'','pdfEngine':'','bulkPdfEngine':''};
  globalParams: any = {};
  appService: any = { USER_SETTINGS: '', SERVER_CONFIG: '' };
  GENERAL_CONFIG: any = {};
  rowData: any = {};

  actionConfig: ActionConfirmationConfig | null = null;

  constructor(
    private globalService: GlobalService,
    private workspaceService: WorkspaceService,
    private appServiceProvider: AppService
  ) { }

  ngOnInit(): void {
    this.initializeFromServices();
    this.buildConfig();
  }

  /**
   * Extract object from various input formats
   */
  private extractObject(input: any): any {
    if (typeof input === 'string') {
      try {
        return safeJsonInput<any>(input, null, 'basket-maintenance-delete.parse1');
      } catch (e) {
        return {};
      }
    }
    return input && typeof input === 'object' ? input : {};
  }

  /**
   * Initialize from services instead of @Input decorators
   */
  private initializeFromServices(): void {
    const urls = this.extractObject(this.globalService.GENERAL_CONFIG || {});
    if (Object.keys(urls).length > 0) this.baseURLs = urls;

    const globalParams = this.extractObject(this.globalService.global?.globalParams || {});
    if (Object.keys(globalParams).length > 0) this.globalParams = globalParams;

    const activeScreen = this.workspaceService.workspaceFactory?.activeScreen || {};
    const rowData = this.extractObject(activeScreen?.data || {});
    if (Object.keys(rowData).length > 0) this.rowData = rowData;

    const filterParams = this.extractObject(
      activeScreen?.filters?.getFilterParams?.() ||
      activeScreen?.filters?.getFilterParamsFromCache?.() ||
      {}
    );
    if (Object.keys(filterParams).length > 0) this.filterParams = filterParams;

    this.appService = this.appServiceProvider;
    this.GENERAL_CONFIG = urls;
  }

  private buildConfig(): void {
    if (!this.GENERAL_CONFIG?.base_url || !this.rowData || !Object.keys(this.rowData).length) {
      return;
    }

    const globalParams = this.globalParams || {};

    this.actionConfig = {
      modalTitle: 'Delete Basket',
      confirmationMessage: '',
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      showMinimize: true,
      successMessage: 'The Basket was successfully deleted',
      errorMessagePrefix: 'Error deleting basket',

      actionCode: 'obachr',
      contentType: 'urlencoded',
      responseFormat: 'callSuccess',

      payloadMapping: {
        'basket_id': 'BASKET_ID'
      },

      baseUrl: this.GENERAL_CONFIG.base_url,
      globalParams,
      filterParams: this.filterParams,
      rowData: this.rowData,
      ssoId: this.appService.USER_SETTINGS?.user?.sso_id ?? '',
      refreshEventDetail: {}
    };
  }

  onConfirmed(): void {
    this.requestGridUpdate.emit('refresh');
  }

  onCancelled(): void {
    this.requestGridUpdate.emit('cancel');
  }

  onClosed(): void {
    this.requestGridUpdate.emit('cancel');
  }
}
